import RTRBookReaderContainer from './RTRBookReaderContainer';
export default RTRBookReaderContainer;
